import { render, staticRenderFns } from "./addworkers.vue?vue&type=template&id=6a24d3b3"
import script from "./addworkers.vue?vue&type=script&lang=js"
export * from "./addworkers.vue?vue&type=script&lang=js"
import style0 from "./addworkers.vue?vue&type=style&index=0&id=6a24d3b3&prod&lang=less"
import style1 from "./addworkers.vue?vue&type=style&index=1&id=6a24d3b3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports